import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getAllCustomer, toggleCustomer } from "../../actions/CustomerActions";
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import DataTable from "react-data-table-component";
import { ThreeDots } from "react-loader-spinner";
import { doneByDriver, getAllVehicleReplacement, getVehicleReplacementByDriverId } from "../../actions/VehicleReplacementsActions";
import Toast from "../../components/Toast";
import Mobilemenu from "../../layouts/mobile-menu";

function DriverVehicles() {

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);

    useEffect(() => {
        dispatch(getVehicleReplacementByDriverId(localStorage.getItem('user')));
    }, [page])

    const onChangePage = (page) => {
        // page)
        setPage(page);
    }
    // const toggleStatus = (id) => {
    //     dispatch(toggleCustomer(id));
    // }

    const loading = useSelector(state => state?.loading?.loading);
    const driverVehicles = useSelector(state => state?.vehicleReplacements?.driverVehicles)
    // vehicleReplacements)

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            },
        },
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '60px', // override the row height
                backgroundColor: '#fff !important',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        body: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            }
        },
        headCells: {
            style: {
                paddingLeft: '20px', // override the cell padding for head cells
                paddingRight: '20px',
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
                backgroundColor: 'rgb(241, 245, 248)',
                // justifyContent: 'center'
            },
        },
        cells: {
            style: {

                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                backgroundColor: 'rgb(241,245,248)',
                borderTop: 'none !important',
            },
        }
    };

    const columns = [
        {
            name: 'ID',
            selector: (row, index) => index + 1,
        },
        {
            name: 'CUSTOMER NAME',
            selector: row => row?.customer_name,
        },
        {
            name: 'PLATE NUMBER',
            selector: row => row?.vehicle?.plate_number,
        },
        {
            name: 'VEHICLE CODE',
            selector: row => row?.vehicle?.vehicle_code?.name,
        },
        {
            name: 'STATUS',
            selector: row => row?.replace_vehicle_status_master?.name,
        },
        // {
        //     name: 'STATUS',
        //     selector: row => <div className="d-flex align-items-center form-check form-switch">
        //         <input onChange={(e) => toggleStatus(row.customer_id)} type="checkbox"
        //             defaultChecked={row.status} className="form-check-input" />
        //     </div>,
        // },
        {

            selector: row => {
                return (<>
                    <div className="dropdown">
                        <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
                            <span className="d-flex align-items-center fs-base justify-content-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                                Actions
                            </span>
                        </button>
                        <div className="dropdown-menu w-40">
                            <div className="dropdown-content">
                                <Link className="d-flex align-items-center fs-base py-1" to={`/driver/replacementForm/${row.id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Fill </Link>
                            </div>
                        </div>
                    </div>
                </>)
            },
        },
    ];


    return (

        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> :
                            <span>
                                <h2 className="intro-y fs-lg fw-medium mt-10">
                                    Vehicles
                                </h2>
                                <div className="grid columns-12 gap-6 mt-5">
                                    <div className="intro-y g-col-12 d-flex flex-wrap flex-sm-nowrap justify-content-between align-items-center mt-2">
                                        {/* <Link to="/replacementOfVehicle/add">
                                            <button className="btn btn-primary shadow-md me-2">Add New</button>
                                        </Link> */}
                                        <div className="w-full w-sm-auto mt-3">
                                            <div className="ms-auto w-56 position-relative text-gray-700 dark-text-gray-300">
                                                <input type="text" className="form-control w-56 box border-white dark-border-dark-3 pe-10 placeholder-theme-13" placeholder="Search..." />
                                                <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                            </div>
                                        </div>
                                    </div>
                                    < div className="intro-y g-col-12">
                                        <div className='mt-2'>
                                            <DataTable
                                                className="overflow-lg-visible"
                                               columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                                data={driverVehicles && driverVehicles.length > 0 ? driverVehicles : []}
                                                striped={true}
                                                highlightOnHover={true}
                                                pagination={true}
                                                customStyles={customStyles}
                                                responsive={true}
                                            // paginationTotalRows={vehicleReplacements && vehicleReplacements.length > 0 ? vehicleReplacementsPagination.total : 0}
                                            // paginationServer={true}
                                            // onChangePage={(page) => onChangePage(page)}
                                            // paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            // onChangeRowsPerPage={(currentRowsPerPage, currentPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                            // paginationPerPage={10}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </span>
                    }
                </div>
            </div>
        </React.Fragment >
    )
}

export default DriverVehicles;